import { observer } from 'mobx-react';
import * as React from 'react';
import * as style from '../../../../ProgramSummary/style.module.css';
import { TranslationsState } from '@execonline-inc/translations';
import { AlarmClockIcon } from '@execonline-inc/execonline-ui';
import ClickableTooltip from '../../../../ClickableTooltip';
import { localizer } from '../Percentage';
import { L, T } from '../../../../../Translations';
import { formatISO } from 'date-fns';

interface Props {
  moduleEndsOn: Date;
  percentComplete: number;
  translationsState: TranslationsState;
}

const ScheduledRunLate: React.FC<Props> = ({
  moduleEndsOn,
  percentComplete,
  translationsState,
}) => {
  const formattedDate = moduleEndsOn.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div
      className={style.scheduledRunLate}
      data-test-module-due={formatISO(moduleEndsOn, { representation: 'date' })}
      data-testid="percent-complete-scheduled-run-late"
    >
      <p
        className={style.percentage}
        tabIndex={0}
        aria-label={`Progress: ${localizer(percentComplete)(translationsState)}`}
      >
        {localizer(percentComplete)(translationsState)}
      </p>
      <ClickableTooltip
        place="top"
        tooltipIcon={<AlarmClockIcon color="inherit" size="xl" />}
        tooltipId="scheduled-run-tooltip"
        backgroundColor="#D8625A"
        ariaLabelOverride={`Program Schedule Reminder: Your current segment was due on ${formattedDate}`}
        translationsState={translationsState}
      >
        <span className={style.tooltipText}>
          <T
            kind="Your current segment was due on <date/>"
            date={<L localizeable={moduleEndsOn} format="long-month-day-year" />}
          />
        </span>
      </ClickableTooltip>
    </div>
  );
};

export default observer(ScheduledRunLate);
